import { render, staticRenderFns } from "./EditCustomerView.vue?vue&type=template&id=5557e8b4&"
import script from "./EditCustomerView.vue?vue&type=script&lang=js&"
export * from "./EditCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerView.vue?vue&type=style&index=0&id=5557e8b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports